import { render, staticRenderFns } from "./BeneficiariesPage.vue?vue&type=template&id=7302c5f0&"
import script from "./BeneficiariesPage.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports